import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

function TopicContentMaxWidth(props) {
  const {
    children,
    theme: {
      controls: {
        topicContent,
      },
    },
    className,
    ...otherProps
  } = props;

  return (
    <div {...otherProps} className={cx(styles.block, className)}>
      <style jsx>{`
        .${styles.block}
          max-width ${topicContent.widgetsMaxWidth}px
      `}</style>
      {children}
    </div>
  );
}

TopicContentMaxWidth.propTypes = {
  /** @ignore */
  isMobile: PropTypes.bool,
  /** @ignore */
  theme: themePropTypes(`{
    controls: {
      topicContent: {
        widgetsMaxWidth,
      }
    }
  }`),
  /** @ignore */
  className: PropTypes.string,
};

const TopicContentMaxWidthWithHOC = withTheme(TopicContentMaxWidth);
TopicContentMaxWidthWithHOC.displayName = 'TopicContentMaxWidth';

export default TopicContentMaxWidthWithHOC;
